import axiosInstance from './axiosInstance'

export const getPayoutById = (payoutId) => {
  return axiosInstance.get(`/payouts/${payoutId}`)
}

export const getPayouts = (page = 1, limit = 50, orderByKey = 'id', direction = 'asc') => {
  return axiosInstance.get(`/payouts?page=${page}&limit=${limit}&orderByKey=${orderByKey}&direction=${direction}`)
}

export const createPayout = (data) => {
  return axiosInstance.post('/payouts', data)
}

export const updatePayout = (payoutId, data) => {
  return axiosInstance.put(`/payouts/${payoutId}`, data)
}

export const deletePayout = (payoutId) => {
  return axiosInstance.delete(`/payouts/${payoutId}`)
}

export const getPayoutByProjectId = (projectId) => {
  return axiosInstance.get(`/payouts/by-project-id/${projectId}`)
}

export const updatePayoutByProjectId = (projectId, data) => {
  return axiosInstance.put(`/payouts/by-project-id/${projectId}`, data)
}

export const payoutCommissionEdit = (commissionType, ownerId, amount) => {
  return axiosInstance.post('/payouts/commission/edit', { commissionType, ownerId, amount })
}

export const getPayoutRateForSalesUsers = () => {
  return axiosInstance.get('/payouts/commission/rate-for-sales-users')
}

export const getPayoutProjects = (isOverage = false, filterProjectStatus = 'All', filterStartDate = '2000-01-01', filterEndDate = '2099-01-01', filterSalespersonId = 'All', page = 1, limit = 50, search = '', orderByKey = 'id', direction = 'asc') => {
  return axiosInstance.post(
    `/payouts/commission/projects?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`,
    { isOverage, filterProjectStatus, filterStartDate, filterEndDate, filterSalespersonId }
  )
}

export const getPayoutChangeOrders = (filterStartDate = '2000-01-01', filterEndDate = '2099-01-01', filterUserId = 'All', page = 1, limit = 50, search = '', orderByKey = 'id', direction = 'asc') => {
  return axiosInstance.post(
    `/payouts/commission/change-orders?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`,
    { filterStartDate, filterEndDate, filterUserId }
  )
}

export const runPayoutPayProjects = (isOverage = false, projectIds = []) => {
  return axiosInstance.post('payouts/commission/run-pay-projects', { isOverage, projectIds })
}

export const runPayoutPayChangeOrders = (isOverage = false, changeOrderIds = []) => {
  return axiosInstance.post('payouts/commission/run-pay-change-orders', { isOverage, changeOrderIds })
}
